import type { AccessConstraint } from '@sb/shared/access';

/** Access constraints for the account-settings routes. */
export const accountSettingsAccess = {
  settings: { permission: ['Manage account'] },
  permissions: { permission: ['Manage account', 'Edit group permissions'], permissionCheck: 'all' },
} satisfies Record<string, AccessConstraint>;
